/**
 * Owner: Masa Bayu
 * File: local-runtime.ts
 * Date:Time: 2026-09-18 11:11
 * Description: QXCircle in-process engine — guest by default · no mock account.
 */

import type { AccountBundle } from '../account/account-types';
import { loadQxCircleLabFixtures } from './qxcircle-test-harness';
import { QxCircleService } from './qxcircle.service-social';
import { qxCircleAuthorFromAccount } from './qxcircle-account';

let service: QxCircleService | null = null;
let sessionAccount: AccountBundle | null = null;

export function getQxCircleEngine(): QxCircleService {
  if (service === null) {
    service = new QxCircleService();
  }
  return service;
}

export function getQxCircleLocalAccount(): AccountBundle | null {
  return sessionAccount;
}

export function getQxCircleLocalAccountId(): string | null {
  return sessionAccount?.user.id ?? null;
}

export function getQxCircleSessionHandle(): string | null {
  if (sessionAccount === null) {
    return null;
  }
  return qxCircleAuthorFromAccount(sessionAccount).authorHandle;
}

export function isQxCircleSignedIn(): boolean {
  return sessionAccount !== null;
}

/** Product auth bridge — only set from a real session; never invent an account. */
export function setQxCircleSessionAccount(account: AccountBundle | null): void {
  sessionAccount = account;
}

export function resetQxCircleEngineForTests(): void {
  sessionAccount = null;
  service = new QxCircleService();
  loadQxCircleLabFixtures(service);
}
